import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Link, Container, Typography, CardMedia, Stack } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Page from '../components/Page';
import Logo from '../components/Logo';
import event from '../assets/images/event.png';
// sections
import { RegisterForm } from '../sections/auth/register';
import AuthSocial from '../sections/auth/AuthSocial';
import CustomStepper from '../components/customStepper';
import CustomButton from '../components/CustomButton';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(1, 1),
}));

// ----------------------------------------------------------------------

export default function Register() {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  return (
    <Page title="Inscription">
      <RootStyle>
        <Container>
          <ContentStyle>
            <Stack pb={3} spacing={3} justifyContent={'start'} alignItems={'start'}>
              <CustomButton type='back' href='/' buttonText={"Retour à l'accueil"} />
              <Logo />
              <Stack justifyContent={'start'} alignItems={'start'} spacing={1}>
                <Typography variant="h5" textAlign='center'>
                  Créer un compte
                </Typography>
                <Typography fontSize={18} textAlign='start' sx={{ color: 'text.secondary' }} >
                  Commencez à vendre vos billets en quelques minutes
                </Typography>
              </Stack>


            </Stack>

            <RegisterForm />

            <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mt: 3 }}>
              En vous s'inscrivant, vous accepter&nbsp;
              <Link underline="always" color= '#5E17EB'  href="https://support.choptonticket.com/fr/categories/legacy/articles/cgp">
                Les conditions de confidentialité.
              </Link>
              et <Link underline="always" color= '#5E17EB' href="https://support.choptonticket.com/fr/categories/legacy/articles/cgu">
                Les conditions d'utilisation de Choptonticket.
              </Link>
            </Typography>
            <Typography fontSize={17} color={'text.secondary'} align="center" sx={{ my: 3 }}>
              Vous avez déja un compte ?{' '}
              <Link underline='hover' sx={{ color: '#5E17EB' }} component={RouterLink} to="/login">
                Se connecter
              </Link>
            </Typography>


          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
